import {createContext, useReducer} from 'react';
import PropTypes from 'prop-types';

const defaultAppConfigState = {
  menuIsVisible: false,
  chatIsVisible: false,
};
const AppConfigState = createContext(defaultAppConfigState);
const {Provider} = AppConfigState;

const reducer = (state, action) => {
  switch (action.type) {
    case 'toggleMenu':
      return {
        ...state,
        menuIsVisible: !state.menuIsVisible,
      };
    case 'toggleChat':
      return {
        ...state,
        chatIsVisible: !state.chatIsVisible,
      };
    case 'closeChat':
      return {
        ...state,
        chatIsVisible: false,
      };
    default:
      throw new Error('Unrecognizable app config action');
  }
};

const AppConfigProvider = ({children}) => {
  const [state, dispatch] = useReducer(reducer, defaultAppConfigState);

  return (
    <Provider value={{state, dispatch}}>
      {children}
    </Provider>
  );
}

AppConfigProvider.propTypes = {
  children: PropTypes.node
}

export {
  AppConfigProvider,
  AppConfigState,
};
